export const Paths = {
    Start: 'start',
    PatientsSearch: 'patients-search',
    OrderCreation: 'order-creation',
    Orders: 'orders',
    Reports: 'reports',
    Shop: 'shop',
    Documents: 'view-documents',
    Info: 'info',
} as const;
